import { IUser } from 'models'
import debug from 'debug'

const log = debug('helpers')

export function isUserRegistered (user: IUser | undefined, scheduleItemId: number): boolean {
  log(user)
  return user?.items?.includes(scheduleItemId) ?? false
}
